module.exports = __webpack_public_path__ + "static/media/MorpheusCoachWhite.f2896932.svg";